var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"time-line-event",attrs:{"to":_vm.route}},[_c('div',{staticClass:"detail"}),_vm._v(" "),_c('div',{staticClass:"event"},[_c('div',[_vm._v(_vm._s(_vm.event.title)+" | "+_vm._s(_vm.event.description))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.datetime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e79edb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watch/widgets/timeline/TimeLineEvent.vue
// module id = null
// module chunks = 